import { render, staticRenderFns } from "./TheGameGalleryBarIntro.vue?vue&type=template&id=e788f170"
import script from "./TheGameGalleryBarIntro.vue?vue&type=script&lang=js"
export * from "./TheGameGalleryBarIntro.vue?vue&type=script&lang=js"
import style0 from "./TheGameGalleryBarIntro.vue?vue&type=style&index=0&id=e788f170&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports